export default __webpack_public_path__ + "static/media/home-events-conference-img-08.a72ca29f.jpg";